'use client';

import React from 'react';
import { PresenceStatus } from '@/hooks/usePresence';

interface PresenceDotProps {
  status: PresenceStatus;
  size?: 'sm' | 'md';
  showLabel?: boolean;
}

const STATUS_CONFIG: Record<PresenceStatus, { dot: string; label: string; ring: string }> = {
  online:       { dot: 'bg-emerald-500', label: 'Online',        ring: 'ring-emerald-200' },
  away:         { dot: 'bg-amber-400',   label: 'Away',          ring: 'ring-amber-200' },
  in_a_meeting: { dot: 'bg-violet-500',  label: 'In a meeting',  ring: 'ring-violet-200' },
  offline:      { dot: 'bg-slate-300',   label: 'Offline',       ring: 'ring-slate-100' },
};

export default function PresenceDot({ status, size = 'sm', showLabel = false }: PresenceDotProps) {
  const cfg = STATUS_CONFIG[status] ?? STATUS_CONFIG.offline;
  const dotSize = size === 'md' ? 'w-3 h-3' : 'w-2.5 h-2.5';

  return (
    <span className="inline-flex items-center gap-1.5">
      <span
        className={`${dotSize} rounded-full ${cfg.dot} ring-2 ${cfg.ring} shrink-0`}
        title={cfg.label}
      />
      {showLabel && (
        <span className="text-[11px] text-slate-500">{cfg.label}</span>
      )}
    </span>
  );
}
